import { getBrandCurrency } from 'redux/brand';
import { useAppSelector } from 'redux/store';
import { getOrderTotalPriceBreakdown } from 'redux/order';
import { computePrice } from 'utils/price';
import { useTranslation } from 'react-i18next';
import { Options } from 'components/RadioSelect';
import { ReactComponent as BankCard } from './bankCard.svg';
import { PaymentMode } from '../usePaymentVm';

export const usePaymentModeVM = () => {
    const { i18n } = useTranslation();

    const currency = useAppSelector(getBrandCurrency);
    const totalPriceBreakdown = useAppSelector(getOrderTotalPriceBreakdown);

    const paymentMethodOptions: Options<PaymentMode>[] = [
        {
            name: 'bankCard',
            icon: BankCard,
            value: 'stripe',
        },
    ];

    return {
        currency,
        totalPriceBreakdown,
        canPay: totalPriceBreakdown && totalPriceBreakdown.totalInclTax > 0,
        amountWithCurrency:
            currency && totalPriceBreakdown
                ? computePrice(i18n, totalPriceBreakdown.totalInclTax, currency)
                : '',
        paymentMethodOptions,
    };
};
